module.exports = {
      id: "icon-upload-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-upload",
      toString: function () {
        return this.url;
      }
    }